import React, { Fragment, useEffect, useState } from 'react';
import MaterialTable from 'material-table';

import { config, tableIcons, tableWorkersColumns, BACKEND_URL } from '../services/config';
import axios from 'axios';
import { useRecoilState } from 'recoil';
import { userState } from '../atoms/userAtom';

export default function WorkersTable() {
  const [data, setData] = useState();
  const [userToken, setUserToken] = useRecoilState(userState);
  useEffect(() => {
    if (userToken !== '') {
      getWorkerHandler();
    }
  }, [userToken]);

  const getWorkerHandler = async () => {
    axios
      .get(`${BACKEND_URL}/api/v1/worker`, config(userToken))
      .then((res) => setData(res.data))
      .catch((err) => console.log(err));
  };
  const addWorkHandler = async (data) =>
    axios
      .post(`${BACKEND_URL}/api/v1/worker`, data, config(userToken))
      .then(() => getWorkerHandler())
      .catch((err) => console.log(err));
  const updateWorkHandler = async (data) =>
    axios
      .put(`${BACKEND_URL}/api/v1/worker/${data._id}`, data, config(userToken))
      .then(() => getWorkerHandler())
      .catch((err) => console.log(err));
  const deleteWorkHandler = (id) =>
    axios
      .delete(`${BACKEND_URL}/api/v1/worker/${id}`, config(userToken))
      .then(() => getWorkerHandler())
      .catch((err) => console.log(err));
  return (
    <Fragment>
      <MaterialTable
        columns={tableWorkersColumns()}
        data={data}
        title="Arbetare planning"
        options={{ search: false, filtering: false, pageSize: 20 }}
        icons={tableIcons}
        editable={{
          onRowAdd: (newData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                addWorkHandler(newData)
                  .then((res) => console.log(res))
                  .catch((err) => console.log(err));
                resolve();
              }, 1000);
            }),
          onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                const dataUpdate = [...data];
                const index = oldData.tableData.id;
                dataUpdate[index] = newData;
                updateWorkHandler(newData)
                  .then((res) => console.log(res))
                  .catch((err) => console.log(err));
                setData([...dataUpdate]);

                resolve();
              }, 1000);
            }),
          onRowDelete: (oldData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                const dataDelete = [...data];
                const index = oldData.tableData.id;
                dataDelete.splice(index, 1);
                deleteWorkHandler(oldData._id)
                  .then((res) => console.log(res))
                  .catch((err) => console.log(err));
                setData([...dataDelete]);

                resolve();
              }, 1000);
            }),
        }}
      />
    </Fragment>
  );
}
